/**
 * Setear órdenes compañia.
 */
export function setOrdersCompany(state, orders) {
    state.orders = orders
}




